// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3op4G","item":"PaymentsMobile_item__374tC","label":"PaymentsMobile_label__2j9rh","amount":"PaymentsMobile_amount__ZjQI0"};